import { Flex, Text } from 'components'
import { useCurrentUser } from 'components/providers'
import { useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router'
import { IContent } from 'types'
import { createDoc, useBreakpoint, useDisclosure, usePrefCurrentWorkspace } from 'utils'
import ManageTextDrawer from '../components/textContent/ManageTextDrawer'
import TextContentList from '../components/textContent/TextContentList'
import { makeEmptyContent, useMutateContentRecords, useTextContent } from '../utils/contentUtils'
import { RoutePath } from '../utils/routing'

export default function TextContentPage() {
  const [workspaceId] = usePrefCurrentWorkspace()
  const user = useCurrentUser()
  const navigate = useNavigate()
  const { id } = useParams()
  const { onClose, onOpen, open } = useDisclosure()
  const isMobile = useBreakpoint() < 1
  const { updateContentRecord } = useMutateContentRecords()

  const { content, isPending, isError } = useTextContent()
  const status = isPending ? 'pending' : isError ? 'error' : 'success'

  useEffect(() => {
    if (id) onOpen()
    else onClose()
  }, [id])

  function handleDone(doc?: IContent) {
    if (doc?.parentId) {
      navigate(generatePath(RoutePath.TextInfo, { workspaceId, id: doc.parentId }))
    } else {
      navigate(generatePath(RoutePath.Text, { workspaceId }))
    }
  }

  function handleOnSelect(id: string) {
    navigate(generatePath(RoutePath.TextInfo, { workspaceId, id }))
  }

  async function createNewText() {
    const doc = await createDoc(user!.id, 'content', makeEmptyContent(workspaceId))
    updateContentRecord(doc)
    handleOnSelect(doc.id)
  }

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={isMobile ? 4 : 0}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Text Content
      </Text>

      <TextContentList
        content={content}
        onEdit={handleOnSelect}
        onCreate={createNewText}
        status={status}
      />
      <ManageTextDrawer
        open={open}
        id={id}
        onTextSelect={v => navigate(generatePath(RoutePath.TextInfo, { workspaceId, id: v.id }))}
        onDone={handleDone}
        onDelete={handleDone}
      />
    </Flex>
  )
}
